module.exports = __webpack_public_path__ + "media/site_templates/www.skipbinhire.company/images/testimonials-799a4ade6d6a2c7baf57e718eff0cddb.jpg";